import { render, staticRenderFns } from "./SecStudy_SKMP.vue?vue&type=template&id=b0a6cc0e&scoped=true&"
import script from "./SecStudy_SKMP.vue?vue&type=script&lang=js&"
export * from "./SecStudy_SKMP.vue?vue&type=script&lang=js&"
import style0 from "./SecStudy_SKMP.vue?vue&type=style&index=0&id=b0a6cc0e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0a6cc0e",
  null
  
)

export default component.exports